/** Port der `returnUrl`-Logik aus `Pages/Auth/Auth.razor`. */

import { RETURN_URL_STORAGE_KEY } from '@/config/appConfig';

/** Pendant zu `SaveReturnUrl()`. */
export function saveReturnUrl(url: string): void {
  window.sessionStorage.setItem(RETURN_URL_STORAGE_KEY, url);
}

/** Pendant zu `GetSavedReturnUrl()`: einmalig lesen, danach ist der Eintrag verbraucht. */
export function takeReturnUrl(): string | null {
  const returnUrl = window.sessionStorage.getItem(RETURN_URL_STORAGE_KEY);
  if (returnUrl === null || returnUrl.length === 0) {
    return null;
  }

  window.sessionStorage.removeItem(RETURN_URL_STORAGE_KEY);
  return returnUrl;
}

/**
 * Pendant zu `GetReturnUrl()`: schneidet ab `returnUrl=` bis zum nächsten `&` und dekodiert.
 * Die Suche läuft bewusst über die gesamte URL — genau wie `uri.IndexOf("returnUrl=")`.
 */
export function readReturnUrlFromLocation(href: string): string | null {
  const parameterName = 'returnUrl=';
  const parameterIndex = href.indexOf(parameterName);
  if (parameterIndex === -1) {
    return null;
  }

  const valueStart = parameterIndex + parameterName.length;
  const valueEnd = href.indexOf('&', valueStart);
  const value = valueEnd === -1 ? href.slice(valueStart) : href.slice(valueStart, valueEnd);

  return decodeURIComponent(value);
}
